module.exports = __webpack_public_path__ + "img/deco_shed.afbdc7ab.png";